var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"panel"}},[(_vm.isOpen)?_c('div',{staticClass:"panel-container"},[(_vm.hasOverlay)?_c('Overlay',{staticClass:"panel-overlay",on:{"click":_vm.close}}):_vm._e(),_c('div',{staticClass:"panel-content",class:_vm.computedClass,style:({
        'background-color': _vm.hasContentBackground
          ? 'transparent'
          : _vm.NebraskaColors.backgroundSecondary
      })},[_vm._t("default")],2)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }